import { lighten, Typography } from '@mui/material';

type UserSysProductProps = {
  value: string;
};

export const UserSysProduct = (props: UserSysProductProps) => {
  const { value } = props;
  return (
    <Typography
      className='sysProduct'
      variant='body2'
      sx={{
        position: 'relative',
        fontSize: '0.8rem',
        backgroundColor: (thm) => lighten(thm.palette.info.light, 0.2),
        borderRadius: 1,
        pl: (thm) => thm.spacing(2.5),
        pr: 1,
        py: 0.5,
        mr: 0.5,
        mb: 0.5,
        '&::after': {
          position: 'absolute',
          content: '" "',
          top: '50%',
          left: (thm) => thm.spacing(1),
          mt: '-0.25em',
          backgroundColor: '#fff!important',
          width: '0.5em',
          height: '0.5em',
          boxShadow: '0 -1px 1px 0 rgba(0, 0, 0, 0.3)',
          borderRadius: '500rem',
        },
      }}
    >
      {value}
    </Typography>
  );
};
